import type { GetContentStorageDTO } from '../service/ai-disclosure.repository.interface';
import type { GetContentStorageRequest, GetContentStorageResponse } from '../type/ai-disclosure.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetContentStorage } from '@/infrastructure/api-functions/interface/get-content-storage.interface';

@injectable()
export class GetContentStorageDTOImpl implements GetContentStorageDTO {
    constructor(
        @inject(GetContentStorage)
        private readonly _getContentStorageApi: GetContentStorage
    ) {
    }

    async fetch(params: GetContentStorageRequest): Promise<GetContentStorageResponse> {
        return await this._getContentStorageApi.getContentStorage(params);
    }
}
